import { render, staticRenderFns } from "./CardPropertyDefault.vue?vue&type=template&id=54a55091&scoped=true&"
import script from "./CardPropertyDefault.vue?vue&type=script&lang=js&"
export * from "./CardPropertyDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a55091",
  null
  
)

export default component.exports
import {QInput} from 'quasar'
component.options.components = Object.assign({QInput}, component.options.components || {})
